export default __webpack_public_path__ + "static/media/stuartLogo.d298aaf2.png";